import CitationGeneratorPage from 'components/citation-generator-page';
import OscolaGuide from 'components/guides/oscola-guide';
import titleTemplate from 'lib/title-template';
import { NextPage } from 'next';

const OSCOLAHomePage: NextPage<{ error: Record<string, unknown> }> = ({
  error,
}) => {
  return (
    <CitationGeneratorPage
      title={titleTemplate('Free OSCOLA Citation & Bibliography Generator')}
      metaDescription="Our automatic OSCOLA citation generator lets you create instant Works Cited & one-click citations for books, journal articles, websites, and more."
      forceCitationStyle="OSCOLA (Oxford University Standard for Citation of Legal Authorities)"
      error={error}
      guideStyle="OSCOLA"
    >
      <OscolaGuide />
    </CitationGeneratorPage>
  );
};

export default OSCOLAHomePage;
